// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { Switch, Redirect } from 'react-router-dom';
import { get } from 'lodash/fp';
import GlobalLeaderboardSportsFilterBox from 'app/components/sportsFilters/GlobalLeaderboardSportsFilterBox';
import GlobalLeaderboardContent from 'app/components/leaderboard/GlobalLeaderboardContent';
import Page from 'app/containers/parts/Page';

type Props = {
  competitionSlug?: string,
  history: Object,
  isLoading: boolean,
  leaderboardName?: string,
  locale: string,
  sportsList: Array<Object>,
  sportSlug?: string,
  url: string
};

class GlobalLeaderboard extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    competitionSlug: undefined,
    leaderboardName: undefined,
    sportSlug: undefined
  };

  componentDidMount() {
    this.redirectRoute();
  }

  componentDidUpdate() {
    this.redirectRoute();
  }

  redirectRoute() {
    const {
      competitionSlug,
      history,
      isLoading,
      leaderboardName,
      sportsList,
      sportSlug,
      url
    } = this.props;

    if (!isLoading && leaderboardName) {
      if (!sportSlug) {
        history.replace(`${url}/${sportsList[0].slug}`);
      } else if (!competitionSlug) {
        const sport = sportsList.find(s => s.slug === sportSlug);
        const defaultCompetitionSlug = get('subcategories[0].slug', sport);
        history.replace(`${url}/${defaultCompetitionSlug}`);
      } else if (leaderboardName === 'how-to-play' && competitionSlug !== 'epl') {
        history.replace(`/ultimate-champion/leaderboard/${sportSlug}/${competitionSlug}`);
      }
    }
  }

  render() {
    const {
      competitionSlug,
      isLoading,
      leaderboardName,
      locale,
      sportsList,
      sportSlug
    } = this.props;

    return (
      <Page>
        <GlobalLeaderboardSportsFilterBox
          activeSport={sportSlug}
          activeSubCategory={competitionSlug}
          isLoading={isLoading}
          namespace={`/ultimate-champion/${leaderboardName}`}
          showAll={false}
          sportsList={sportsList}
          spartan={false}
        />
        {!isLoading && sportSlug && competitionSlug && leaderboardName && (
          <GlobalLeaderboardContent
            sportSlug={sportSlug}
            competitionSlug={competitionSlug}
            leaderboardName={leaderboardName}
            locale={locale}
            sportsList={sportsList}
            spartan={false}
          />
        )}
        <Switch>
          <Redirect
            exact
            from="/ultimate-champion"
            to="ultimate-champion/how-to-play/football/epl"
          />
        </Switch>
      </Page>
    );
  }
}

function mapStateToProps(state: GlobalState, { match, history }) {
  const { competition, leaderboardName, sport } = match.params;

  return {
    url: match.url,
    history,
    sportSlug: sport,
    competitionSlug: competition,
    leaderboardName,
    locale: state.settings.locale,
    sportsList: state.ultimateChallenge.competitionsList,
    isLoading: state.ultimateChallenge.competitionsList.length === 0
  };
}

export default connect(
  mapStateToProps,
  null
)(GlobalLeaderboard);
